import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {LocationModel} from './location.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'courtId',
  locationId: 'locationId',
  name: 'name',
  status: 'status',

  location: 'location',
};

export class CourtModel extends Model {
  locationId!: number;
  name!: string;
  status!: string;

  location?: LocationModel;

  static getInstance(data: Params): CourtModel {
    const model = new CourtModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'location') {
        (model as Params)[prop] = LocationModel.getInstance(data[propsMapping[prop]]);
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   urlParams?: HttpParams
  // ): Observable<ListState<CourtModel>> {
  //   return apiService
  //     .get('courts', urlParams)
  //     .pipe(
  //       map((data: Params): ListState<CourtModel> => {
  //         const list: CourtModel[] = data['data'].map((item: Params): CourtModel =>
  //           CourtModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
